import { useEffect, useRef } from "react"
import { addToast } from "@heroui/react"
import { KeyRound } from 'lucide-react';
import { useSelector } from "react-redux";

const UnlockIcon = () => (
    <span style={{ height: '50px', width: '30px' }} className="relative flex gap-1 items-start">
        <span className="w-5 h-5 rounded-full bg-[#B4BE86] shrink-0" style={{backgroundColor: "#B4BE86"}}/>
        <span className="w-[1px] bg-base-text/50 h-full" style={{backgroundColor: "#27485C", width: "1px"}}/>
    </span>
)

export const useTaskUnlockToast = () => {
    const hintProgress = useSelector(state => state.hintProgress)
    const shownThisSession = useRef(new Set())

    const checkUnlock = (show, id, title, description) => {
        const key = `unlock-toast-${id}`
        const dismissed = localStorage.getItem(key) === 'true'

        if (show && 
            !dismissed &&
            !shownThisSession.current.has(id)
        ) {
            shownThisSession.current.add(id)
            addToast({
                title,
                description,
                radius: "lg",
                timeout: 10000,
                classNames: {
                    base: "bg-white/50 dark:bg-white/10 backdrop-blur-md border-base-text/20 dark:border-white/10",
                    description: "font-light text-base-text",
                    title: "font-light text-base-text",
                    icon: "fill-white/0"
                },
                icon: <KeyRound className="text-base-text size-5" strokeWidth={1} />,
                // icon: <UnlockIcon />,
                onClose: () => localStorage.setItem(key, 'true')
            })
        }
    }

    useEffect(() => {
        checkUnlock(
            hintProgress?.flashcardFrontHintShown && hintProgress?.flashcardBackHintShown,
            "vocabulary-task",
            "ホームに、新しいタスクが待っています。",
            ""
        )
    }, [hintProgress?.flashcardFrontHintShown, hintProgress?.flashcardBackHintShown])

    useEffect(() => {
        checkUnlock(
            hintProgress?.videoHintShown,
            "chat",
            "ホームに、新しいタスクが待っています。",
            // "アオメとの対話が、始まります。"
        )
    }, [hintProgress?.videoHintShown])
}